function e(e,r){return e.reduce(((e,t)=>({...e,[`${t[r]}`]:t})),{})}export{e as default};
